import React from 'react';
import classnames from 'classnames';

import Icon from 'monday-ui-react-core/dist/Icon';

import './icon-component.scss';

export default function IconComponent({ icon, secondary, className, ...iconProps }) {
  if (!icon) return null;

  return (
    <div className={classnames('icon-component', className, { 'secondary-color': secondary })}>
      <Icon icon={icon} {...iconProps} />
    </div>
  );
}
